/* import/no-extraneous-dependencies*/
import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik, Form, Field, FieldArray } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { commonService, raiseClaimService } from '../../services';
import { noEscChar, policyRegexHyphenSlashScore } from '../../helpers/commonYupValidations';
import { convertedClaimIntimation } from '../../helpers/common';
import DatePicker from 'react-datepicker';
import moment, { invalid } from 'moment';
import { jwtDecode } from "jwt-decode";
import ClaimStatusFieldWithModal from './ClaimStatusFieldWithModal';
import AmountInput from '../common/AmountInput';
import { aesUtil } from '../../utils/aesUtil';

const transitTypeDropdown = ["K1", "K2", "K3", "Other"]
let storageTransitTypeDropdown = ["Storage", "Transit", "Miscellaneous", "Liability"]
//Self Surveyor, Default Surveyor(Simplify/ Mack)

const DatePickerField = ({ label, name, values, setFieldValue, disabled }) => {
    return (
        <li className='col-md-6 mb-4'>
            <div className="fieldArrayBox">
                <label htmlFor={name} className="form-label">{label}</label>
                <br />
                <DatePicker
                    selected={values?.[name] ? values[name] : ""}
                    onChange={(date) => setFieldValue(name, date)}
                    dateFormat="dd/MM/yyyy"
                    className={`form-control full-width-datepicker`}
                    name={name}
                    placeholderText={`Enter ${label}`}
                    disabled={disabled}
                />
            </div>
        </li>
    );
};

const RaiseClaimModal = ({ fetchRaiseClaimList, FYList, policyTypeList, action, closeModal, isOpen }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [claimTemplateList, setClaimTemplateList] = useState(null);
    const [policySubTypeList, setPolicySubTypeList] = useState([]);
    const [surveyorCompanyDropdownList, setSurveyorCompanyDropdownList] = useState([]);
    const [locationDropdownList, setLocationDropdownList] = useState([]);
    const [majorCauseLossList, setMajorCauseLossList] = useState([]);
    const [claimStatusDropdownList, setClaimStatusDropdownList] = useState([])
    // const [statusByUserDropdownList, setStatusByUserDropdownList] = useState([])
    const [currentStatusDropdownList, setCurrentStatusDropdownList] = useState([])
    const [divisionDropdownList, setDivisionDropdownList] = useState([])

    //withdrawn
    const [isModalOpen, setModalOpen] = useState(false);
    const [withdrawnId, setWithdrawnId] = useState(0);
    const [nilFSRVALUE, setNILFSRVALUE] = useState("");


    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const decoded = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null;
    const userRole = decoded?.Role;

    const mackInsuranceSurveyor = process.env.REACT_APP_MACK_INSURANCE_SURVEYOR;
    const simplifyInsuranceSurveyor = process.env.REACT_APP_SIMPLIFY_INSURANCE_SURVEYOR;
    const akgSurveyor = process.env.REACT_APP_AKG_INSURANCE_SURVEYOR;

    //withdrawn
    const handleOpenModal = (isChecked) => {
        if (isChecked) {
            setModalOpen(true);
        } else {
            setNILFSRVALUE("")
        }

    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const editValidationSchema = Yup.object().shape({
        // insurerClaimno., surveyorClaimNo., estimatedLossReserve, surveyorId, investigator and fieldSurveyor,
        // .matches(noEscChar(name).regex, noEscChar(name).msg)

        insurerClaimNo: !nilFSRVALUE ? Yup.string().matches(noEscChar("Insurer Claim No.").regex, noEscChar("Insurer Claim No.").msg).max(100, 'Insurer Claim No. must be less than 100 characters')
            .test('insurer-claim-no-validation', 'Insurer Claim No. is required', function (value) {
                if (userRole === 'Insurer') {
                    return value && policyRegexHyphenSlashScore('Insurer Claim No.').regex.test(value);
                }
                return true;
            }) : Yup.string().matches(noEscChar("Insurer Claim No.").regex, noEscChar("Insurer Claim No.").msg),

        surveyorClaimNo: !nilFSRVALUE ? Yup.string().matches(noEscChar("Surveyor Claim No.").regex, noEscChar("Surveyor Claim No.").msg).max(100, 'Surveyor Claim No. must be less than 100 characters')
            .test('surveyor-claim-no-validation', 'Surveyor Claim No. is required', function (value) {
                if (userRole === 'Surveyor') {
                    return value && policyRegexHyphenSlashScore('Surveyor Claim No.').regex.test(value) && value.length <= 100;
                }
                return true;
            }) : Yup.string().matches(noEscChar("Surveyor Claim No.").regex, noEscChar("Surveyor Claim No.").msg),

        surveyorId: !nilFSRVALUE && Yup.string()
            .when(['surveyorAppointmentStatus'], {
                is: (surveyorAppointmentStatus) => {
                    return surveyorAppointmentStatus === 'Appoint Surveyor'
                },
                then: () => Yup.string()
                    .test('surveyor-id-validation', 'Surveyor Name and Company is required', function (value) {
                        if (userRole === 'Insurer') {
                            return !!value;
                        }
                        return true;
                    }),
                otherwise: () => Yup.string().notRequired()
            }),
        currentStatusId: !nilFSRVALUE && Yup.mixed()
            .required('Current Status is required'),
        investigatorName: Yup.string().matches(noEscChar("Investigator Name").regex, noEscChar("Investigator Name").msg)
            .max(100, 'Investigator Name must be less than 100 characters'),
        investigatorEmailId: Yup.string().matches(noEscChar("Email Id").regex, noEscChar("Email Id").msg)
            .email('Invalid Email Id')
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid Email Id')
            .max(100, 'Email Id must be less than 100 characters'),
        // investigatorEmailId: Yup.string().email('Invalid Email Id').max(100, 'Email Id must be less than 100 characters'),
        investigatorContactNo: Yup.string().matches(noEscChar("Contact No.").regex, noEscChar("Contact No.").msg).max(10, 'Contact No. must be 10 digits').matches(/^[0-9]+$/, 'Contact No. must be a number'),
        fieldSurveyorName: Yup.string().matches(noEscChar("Surveyor Name").regex, noEscChar("Surveyor Name").msg).max(100, 'Surveyor Name must be less than 100 characters'),
        fieldSurveyorEmailId: Yup.string().matches(noEscChar("Email Id").regex, noEscChar("Email Id").msg)
            .email('Invalid Email Id')
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid Email Id')
            .max(100, 'Email Id must be less than 100 characters'),
        // investigatorEmailId: Yup.string().email('Invalid Email Id').max(100, 'Email Id must be less than 100 characters'),
        fieldSurveyorContactNo: Yup.string().matches(noEscChar("Contact No.").regex, noEscChar("Contact No.").msg).max(10, 'Contact No. must be 10 digits').matches(/^[0-9]+$/, 'Contact No. must be a number'),
    });

    const handleSurveyorNameComp = () => {
        const { surveyorAppointmentStatus, surveyorCompany, surveyorName, surveyorCompanyId } = action?.claimDetails;
        if (surveyorAppointmentStatus === "Appoint Surveyor" && surveyorCompany && surveyorName) {
            return surveyorCompanyId
        } else if (surveyorAppointmentStatus === "Self Surveyor" || surveyorAppointmentStatus === "Default Surveyor") {
            return surveyorCompany
        }
    }

    const editInitialValues = {
        claimTemplateList: claimTemplateList,
        financialYear: action?.claimDetails?.finYear || "",
        corporateClaimNo: action?.claimDetails?.corPorateNo || "",
        insurerClaimNo: action?.claimDetails?.insurerClaimNo || "",
        surveyorClaimNo: action?.claimDetails?.surveyorClaimNo || "",
        claimIntimationDate: action?.claimDetails?.claimIntimationDate ? moment(action?.claimDetails?.claimIntimationDate, 'DD-MM-YYYY').toDate() : new Date(),
        surveyorAppointmentStatus: action?.claimDetails?.surveyorAppointmentStatus || "",
        surveyorId: action?.claimDetails?.surveyorCompanyId || null,
        surveyorName: handleSurveyorNameComp(),
        policyType: action?.claimDetails?.policyTypeId || 0,
        policyName: action?.claimDetails?.policyNameId || 0,
        policyNumber: action?.claimDetails?.policyNumber || "",
        division: action?.claimDetails?.divisionId || 0,
        placeOfLoss: action?.claimDetails?.placeOfLoss || "",
        dateOfLoss: action?.claimDetails?.dateOfLoss ? moment(action?.claimDetails?.dateOfLoss, 'DD-MM-YYYY').toDate() : "",
        assetNumber: action?.claimDetails?.assetNumber || "",
        shipmentValue: action?.claimDetails?.shipmentValue || "",
        itdDistrict: action?.claimDetails?.itdDistrict || "",
        invoiceNo: action?.claimDetails?.invoiceNo || "",
        invoiceDate: action?.claimDetails?.invoiceDate ? moment(action?.claimDetails?.invoiceDate, 'DD-MM-YYYY').toDate() : "",
        lrNo: action?.claimDetails?.lrNo || "",
        lrDate: action?.claimDetails?.lrDate ? moment(action?.claimDetails?.lrDate, 'DD-MM-YYYY').toDate() : "",
        totalConsignmentValue: action?.claimDetails?.totalConsignmentValue || "",
        estimatedLoss: action?.claimDetails?.estimatedLoss || "",
        estimatedLossReserve: action?.claimDetails?.estimatedLossReserve || "",
        truckNo: action?.claimDetails?.truckNo || "",
        transporter: action?.claimDetails?.transporter || "",
        fromLocation: action?.claimDetails?.fromLocation || "",
        toLocation: action?.claimDetails?.toLocation || "",
        consignmentCargo: action?.claimDetails?.consignmentCargo || "",
        transitType: action?.claimDetails?.transitType || "",
        storageTransitType: action?.claimDetails?.storageTransitType || "",
        majorCauseOfLoss: action?.claimDetails?.majorCauseOfLossId || 0,
        surveyAddress: action?.claimDetails?.surveyAddress || "",
        surveyContactDetails: action?.claimDetails?.surveyContactDetails || "",
        insurerName: action?.claimDetails?.insuranceCompany || "",
        investigatorName: action?.claimDetails?.investigatorName || "",
        investigatorEmailId: action?.claimDetails?.investigatorEmailId || "",
        investigatorContactNo: action?.claimDetails?.investigatorContactNo || "",
        fieldSurveyorName: action?.claimDetails?.fieldSurveyorName || "",
        fieldSurveyorEmailId: action?.claimDetails?.fieldSurveyorEmailId || "",
        fieldSurveyorContactNo: action?.claimDetails?.fieldSurveyorContactNo || "",
        claimStatusId: action?.claimDetails?.claimStatusId || 0,
        // statusByUserId: action?.claimDetails?.userStatusId || 0,
        currentStatusId: action?.claimDetails?.currentStatusId || 0,
        remarks: action?.claimDetails?.remarks || null
    };

    const editRaiseClaim = async (values) => {
        setIsLoading(true);
        let claimManagementResponse = {};

        if (userRole === "Insurer") {
            const payload = {
                raiseClaimId: action?.claimDetails?.raiseClaimId,
                surveyorCompanyId: values?.surveyorId || null,
                insurerClaimNo: values?.insurerClaimNo || "",
                surveyorClaimNo: values?.surveyorClaimNo || "",
                claimStatusId: nilFSRVALUE ? withdrawnId : values?.ClaimStatusId ? values?.ClaimStatusId : 0,
                claimWithdrawnReason: nilFSRVALUE || null,
                currentStatusId: nilFSRVALUE ? currentStatusDropdownList?.length && currentStatusDropdownList.find(status => status.name === "Claim Rejected by Insurer")?.id : values?.currentStatusId ? values?.currentStatusId : 0,
                estimatedLossReserve: values?.estimatedLossReserve ? `${values?.estimatedLossReserve}` : "",
                withdrawnType: 'Insurer',
                investigatorName: values?.investigatorName || "",
                investigatorEmailId: values?.investigatorEmailId || "",
                investigatorContactNo: values?.investigatorContactNo || "",
                fieldSurveyorName: values?.fieldSurveyorName || "",
                fieldSurveyorEmailId: values?.fieldSurveyorEmailId || "",
                fieldSurveyorContactNo: values?.fieldSurveyorContactNo || "",
            }
            claimManagementResponse = await raiseClaimService.updateByInsurer(payload);
        }
        else if (userRole === "Surveyor") {
            const formData = new FormData();
            formData.append("raiseClaimId", action?.claimDetails?.raiseClaimId);
            formData.append("surveyorClaimNo", values?.surveyorClaimNo || "");
            formData.append("insurerClaimNo", values?.insurerClaimNo || "");
            formData.append("currentStatusId", values?.currentStatusId ? values?.currentStatusId : 0);
            formData.append("estimatedLossReserve", values?.estimatedLossReserve || "");
            formData.append("investigatorName", values?.investigatorName || "");
            formData.append("investigatorEmailId", values?.investigatorEmailId || "");
            formData.append("investigatorContactNo", values?.investigatorContactNo || "");
            formData.append("fieldSurveyorName", values?.fieldSurveyorName || "");
            formData.append("fieldSurveyorEmailId", values?.fieldSurveyorEmailId || "");
            formData.append("fieldSurveyorContactNo", values?.fieldSurveyorContactNo || "");
            claimManagementResponse = await raiseClaimService.updateBySurveyor(formData);
        }
        setIsLoading(false);
        if (claimManagementResponse?.data?.isSuccess) {
            toast.success(claimManagementResponse.data.message);
            await fetchRaiseClaimList();
            closeModal();
        }
        else { toast.error(claimManagementResponse?.data?.message); }
    };

    const fetchClaimTemplateDataById = async () => {
        setIsLoading(true);
        const ClaimTemplateResponse = await raiseClaimService.fetchById(action?.policyTypeId);
        if (ClaimTemplateResponse?.data?.isSuccess) {
            const convertedClaim = convertedClaimIntimation(ClaimTemplateResponse.data.data);
            setClaimTemplateList(convertedClaim)
        }
        setIsLoading(false);
    };

    const fetchDivisionDropdownList = useCallback(async (policyTypeId) => {
        const divisionResponse = await commonService.dropdown({ moduleName: "Division", id: 0, purpose: `claim_${policyTypeId}` })
        if (divisionResponse?.data?.isSuccess) {
            let divisionList = divisionResponse.data.data
            divisionList = divisionList?.length > 0 ? divisionList.map(division => ({ label: division.name, value: division.id, })) : []
            setDivisionDropdownList([{ label: "All Division", value: 0 }, ...divisionList])
        }
    }, [])

    const fetchPolicySubType = useCallback(async () => {
        const policyResponse = await commonService.dropdown({ moduleName: "policy-sub-type", id: action?.policyTypeId, purpose: `claim_${action?.claimDetails?.finYear}`, })
        if (policyResponse?.data?.isSuccess) {
            let subTypeList = policyResponse.data.data
            setPolicySubTypeList(subTypeList)
        }
    }, [])

    const fetchStatus = useCallback(async (type) => {
        const statusResponse = await commonService.dropdown({ moduleName: "Status", id: 0, purpose: `status_${type}` })
        if (statusResponse?.data?.isSuccess) {
            let statusList = statusResponse.data.data
            if (type === 1) {
                const defaultId = statusList.find(status => status.name === "Withdrawn")?.id
                setWithdrawnId(defaultId)
                setClaimStatusDropdownList(statusList)
            }
            // if (type === 2) {
            //     setStatusByUserDropdownList(statusList)
            // }
            if (type === 3) {
                setCurrentStatusDropdownList(statusList)
            }
        }
    }, [])

    const fetchCommonDropdownList = useCallback(async (moduleName, role) => {
        const commonResponse = await commonService.dropdown({ moduleName: moduleName, id: 0, purpose: role });
        if (commonResponse?.data?.isSuccess) {
            let list = commonResponse.data.data;
            if (moduleName === "Insurance-Users" || moduleName === "Surveyor-Users") {
                list = list?.length > 0 ? list.map((inc) => ({ label: inc.name, value: inc.id })) : [];
            }
            if (moduleName === "Surveyor-Users") { setSurveyorCompanyDropdownList(list) }
            if (moduleName === "Location") { setLocationDropdownList(list) }
            if (moduleName === "Cause-Of-Loss") { setMajorCauseLossList(list) }
        }
    }, []);

    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    useEffect(() => {
        const fetchList = async () => {
            localStorage.removeItem("claimReasion")
            await fetchClaimTemplateDataById();
            await fetchPolicySubType();
            await fetchDivisionDropdownList(action?.policyTypeId)
            await fetchCommonDropdownList("Location", "")
            await fetchCommonDropdownList("Cause-Of-Loss", "")
            await fetchCommonDropdownList("Surveyor-Users", "")
            await fetchStatus(1)
            // await fetchStatus(2)
            await fetchStatus(3)
        };
        fetchList();
    }, [])

    return (
        <div>
            {claimTemplateList?.length ?
                <Modal isOpen={isOpen} toggle={closeModal} backdrop={'static'} size='xl'>
                    <ModalHeader toggle={closeModal}>
                        {action?.type} Raise Claim</ModalHeader>
                    <ModalBody>
                        <Formik
                            initialValues={editInitialValues}
                            validationSchema={editValidationSchema}
                            onSubmit={editRaiseClaim}
                        >
                            {({ touched, errors, dirty, values, setFieldValue }) =>
                                <Form>
                                    <ul className="fieldArrayBoxUI row">
                                        <li className='col-md-12 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="financialYear" className="form-label">
                                                    Financial Year *
                                                </label>
                                                <Field
                                                    as="select"
                                                    className={`form-control`}
                                                    name="financialYear"
                                                    disabled
                                                >
                                                    {FYList.map((fy) =>
                                                        <option key={fy.value} value={fy.label}>{fy.label}</option>
                                                    )}
                                                </Field>
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="policyType" className="form-label">
                                                    Policy Type *
                                                </label>
                                                <Field
                                                    as="select"
                                                    className={`form-control`}
                                                    name="policyType"
                                                    disabled
                                                >
                                                    <option value="">Select Policy Type</option>
                                                    {policyTypeList?.length &&
                                                        policyTypeList?.map((policyType) => (
                                                            <option key={policyType?.value} value={policyType?.value}>
                                                                {policyType?.label}
                                                            </option>
                                                        ))}
                                                </Field>
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="policyName" className="form-label">
                                                    Policy Name *
                                                </label>
                                                <Field
                                                    as="select"
                                                    className={`form-control`}
                                                    name="policyName"
                                                    disabled
                                                >
                                                    <option value="">Select Policy Name</option>
                                                    {policySubTypeList?.length &&
                                                        policySubTypeList?.map((subType) => (
                                                            <option key={subType?.id} value={subType?.id}>
                                                                {subType?.name}
                                                            </option>
                                                        ))}
                                                </Field>
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="policyNumber" className="form-label">
                                                    Policy Number *
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.policyNumber && errors.policyNumber ? 'is-invalid' : ''}`}
                                                    name="policyNumber"
                                                    placeholder="Enter Policy No."
                                                    disabled
                                                />
                                                {errors.policyNumber && touched.policyNumber ? (
                                                    <p className="errorMsg">{errors.policyNumber}</p>) : null}
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="insurerName" className="form-label">
                                                    Insurance Company *
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control`}
                                                    placeholder="Enter Insurance Company"
                                                    name="insurerName"
                                                    disabled
                                                >
                                                </Field>
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="division" className="form-label">
                                                    Division *
                                                </label>
                                                <Field
                                                    as="select"
                                                    className={`form-control`}
                                                    name="division"
                                                    disabled
                                                >
                                                    <option value="">Select Division</option>
                                                    {divisionDropdownList?.length &&
                                                        divisionDropdownList
                                                            .filter((division) => division.value)
                                                            .map((division) => (
                                                                <option key={division?.value} value={division?.value}>
                                                                    {division?.label}
                                                                </option>
                                                            ))}
                                                </Field>
                                            </div>
                                        </li>
                                        <DatePickerField
                                            label="Claim Intimation Date *"
                                            name="claimIntimationDate"
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            disabled
                                        />
                                        <li className='col-md-6 mb-4' style={{ width: "100%" }}>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="corporateClaimNo" className="form-label">
                                                    Corporate Claim No. *
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control`}
                                                    name="corporateClaimNo"
                                                    placeholder="Enter Corporate Claim No."
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="insurerClaimNo" className="form-label">
                                                    Insurer Claim No. {userRole === "Insurer" ? "*" : ""}
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.insurerClaimNo && errors.insurerClaimNo ? 'is-invalid' : ''}`}
                                                    name="insurerClaimNo"
                                                    placeholder="Enter Insurer Claim No."
                                                    disabled={action?.type === "View"}
                                                />
                                                {errors.insurerClaimNo && touched.insurerClaimNo ? (
                                                    <p className="errorMsg">{errors.insurerClaimNo}</p>) : null}
                                            </div>
                                        </li>
                                        <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="surveyorClaimNo" className="form-label">
                                                    Surveyor Claim No. {userRole === "Surveyor" ? "*" : ""}
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.surveyorClaimNo && errors.surveyorClaimNo ? 'is-invalid' : ''}`}
                                                    name="surveyorClaimNo"
                                                    placeholder="Enter Surveyor Claim No."
                                                    disabled={action?.type === "View"}
                                                />
                                                {errors.surveyorClaimNo && touched.surveyorClaimNo ? (
                                                    <p className="errorMsg">{errors.surveyorClaimNo}</p>) : null}
                                            </div>
                                        </li>

                                    </ul>
                                    <hr style={{ border: '2px solid black' }} />
                                    {values.claimTemplateList && values.claimTemplateList.length > 0 && (
                                        <FieldArray
                                            name="claimTemplateList"
                                            render={() => (
                                                <ul className='fieldArrayBoxUI row'>
                                                    {values?.claimTemplateList?.map((field) => (
                                                        field.behaviour === "Not Required" ||
                                                            (action?.claimDetails.division !== "ITD" && field.rec_name === "itdDistrict") || (policyTypeList.find(policyType => policyType.value === values?.policyType)?.label?.toLocaleLowerCase() !== "stp" && field.rec_name === "shipmentValue") ? null :
                                                            <li className="col-md-6 mb-4" key={`${field.name}`}>
                                                                {field.rec_name !== 'documentUpload' ?
                                                                    <div className="fieldArrayBox">
                                                                        <div className='d-flex'>
                                                                            <label htmlFor={field.rec_name} className="form-label">
                                                                                {field.behaviour === "Mandatory" ? `${field.name} *` : field.name}
                                                                            </label>
                                                                            {field.rec_name === "majorCauseOfLoss" && (
                                                                                values.majorCauseOfLoss &&
                                                                                    ["Accident", "Wet"].some(keyword =>
                                                                                        majorCauseLossList?.find((cause) => cause.id === +values.majorCauseOfLoss)?.name
                                                                                            ?.includes(keyword)
                                                                                    ) ? (
                                                                                    <p className="ms-4" style={{ color: "red" }}>
                                                                                        Spot Survey
                                                                                    </p>
                                                                                ) : null
                                                                            )}
                                                                        </div>
                                                                        {field.fieldType === 'Text' && (
                                                                            <Field
                                                                                type="text"
                                                                                className="form-control"
                                                                                name={field.rec_name}
                                                                                disabled
                                                                                placeholder={`Enter ${field.name}`}
                                                                                value={values[field.rec_name]}
                                                                            />
                                                                        )}
                                                                        {field.fieldType === 'Date' && (
                                                                            <DatePicker
                                                                                selected={
                                                                                    values[field.rec_name]
                                                                                        ? values[field.rec_name]
                                                                                        : ""
                                                                                }
                                                                                disabled
                                                                                dateFormat="dd/MM/yyyy"
                                                                                className={`form-control full-width-datepicker`}
                                                                                name={field.rec_name}
                                                                                placeholderText={`Enter ${field.name}`}
                                                                            />
                                                                        )}

                                                                        {field.fieldType === 'Dropdown' && (
                                                                            <Field
                                                                                as="select"
                                                                                className={`form-control`}
                                                                                name={field.rec_name}
                                                                                disabled
                                                                            >
                                                                                <option value="">Select {field.name}</option>
                                                                                {field.name === "Policy Name" &&
                                                                                    policySubTypeList?.length &&
                                                                                    policySubTypeList?.map((subType) => (
                                                                                        <option key={subType?.id} value={subType?.id}>
                                                                                            {subType?.name}
                                                                                        </option>
                                                                                    ))}

                                                                                {field.name === "Division" && values.policyName &&
                                                                                    divisionDropdownList?.length &&
                                                                                    divisionDropdownList
                                                                                        .filter((division) => division.value)
                                                                                        .map((division) => (
                                                                                            <option key={division?.value} value={division?.value}>
                                                                                                {division?.label}
                                                                                            </option>
                                                                                        ))}
                                                                                {field.name === "ITD District" &&
                                                                                    locationDropdownList?.length &&
                                                                                    locationDropdownList?.map((location) => (
                                                                                        <option key={location?.id} value={location?.id}>
                                                                                            {location?.name}
                                                                                        </option>
                                                                                    ))}
                                                                                {field.name === "Major Cause of Loss" &&
                                                                                    majorCauseLossList?.length &&
                                                                                    majorCauseLossList?.map((loss) => (
                                                                                        <option key={loss?.id} value={loss?.id}>
                                                                                            {loss?.name}
                                                                                        </option>
                                                                                    ))}

                                                                                {field.rec_name === "transitType" &&
                                                                                    transitTypeDropdown?.map((type) => (
                                                                                        <option key={type} value={type}>
                                                                                            {type}
                                                                                        </option>
                                                                                    ))}
                                                                                {field.rec_name === "storageTransitType" && <option value="">Select Storage Transit Type</option>}
                                                                                {field.rec_name === "storageTransitType" &&
                                                                                    storageTransitTypeDropdown?.map((type) => (
                                                                                        <option key={type} value={type}>
                                                                                            {type}
                                                                                        </option>
                                                                                    ))}
                                                                            </Field>
                                                                        )}
                                                                        {field.fieldType === 'Float' && (
                                                                            <AmountInput
                                                                                type="number"
                                                                                step="0.01"
                                                                                className={`form-control`}
                                                                                name={field.rec_name}
                                                                                disabled={field.rec_name !== "estimatedLossReserve"}
                                                                                placeholder={`Enter ${field.name}`}
                                                                            />
                                                                        )}
                                                                    </div> : null}
                                                            </li>
                                                    ))}
                                                </ul>
                                            )}
                                        />
                                    )}
                                    <hr style={{ border: '2px solid black' }} />
                                    {values?.surveyorAppointmentStatus && userRole == "Insurer" && (
                                        <div className="info-header text-center">
                                            <h5 style={{ color: '#007bff' }}>{values?.surveyorAppointmentStatus}</h5>
                                        </div>)}
                                    <ul className='fieldArrayBoxUI row'>
                                        <li className='col-md-6 mb-4' style={{ width: "100%" }}>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="surveyorId" className="form-label">
                                                    Surveyor Name and Company {!(userRole == "Insurer" && values.surveyorAppointmentStatus == 'Appoint Surveyor') ? "" : "*"}
                                                </label>
                                                {values?.surveyorAppointmentStatus === "Appoint Surveyor" &&
                                                    <Field
                                                        as='select'
                                                        className={`form-control ${touched.surveyorId && errors.surveyorId ? 'is-invalid' : ''}`}
                                                        name="surveyorId"
                                                        onChange={(e) => setFieldValue('surveyorId', e.target.value)}
                                                        disabled={!(userRole == "Insurer" && values.surveyorAppointmentStatus == 'Appoint Surveyor') || action?.type === "View"}
                                                    >
                                                        <option value="">Select Surveyor Name and Company</option>
                                                        {surveyorCompanyDropdownList.length && surveyorCompanyDropdownList.map((surveyor) => (
                                                            <option key={surveyor.value} value={surveyor.value}
                                                                // disabled={surveyor.label.includes(mackInsuranceSurveyor) || surveyor.label.includes(simplifyInsuranceSurveyor) || surveyor.label.includes(akgSurveyor)}
                                                            >
                                                                {surveyor.label}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                }
                                                {values?.surveyorAppointmentStatus === "Default Surveyor" &&
                                                    <Field
                                                        type="text"
                                                        className={`form-control`}
                                                        // placeholder="NA"
                                                        name="surveyorName"
                                                        disabled
                                                    />}
                                                {values?.surveyorAppointmentStatus === "Self Surveyor" && <Field
                                                    type="text"
                                                    className={`form-control`}
                                                    // placeholder="NA"
                                                    name="surveyorName"
                                                    disabled
                                                    // value={''}
                                                />}
                                                {errors.surveyorId && touched.surveyorId ? (
                                                    <p className="errorMsg">{errors.surveyorId}</p>) : null}
                                            </div>
                                        </li>
                                    </ul>
                                    <hr style={{ border: '2px solid black' }} />
                                    <ul className='fieldArrayBoxUI row'>
                                        <li className='col-md-4 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="investigatorName" className="form-label">
                                                    Investigator Name
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.investigatorName && errors.investigatorName ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Name"
                                                    name="investigatorName"
                                                    disabled={action?.type === "View"}
                                                >
                                                </Field>
                                                {errors.investigatorName && touched.investigatorName ? (
                                                    <p className="errorMsg">{errors.investigatorName}</p>) : null}
                                            </div>
                                        </li>
                                        <li className='col-md-4 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="investigatorEmailId" className="form-label">
                                                    Investigator Email Id
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.investigatorEmailId && errors.investigatorEmailId ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Email Id"
                                                    name="investigatorEmailId"
                                                    disabled={action?.type === "View"}
                                                >
                                                </Field>
                                                {errors.investigatorEmailId && touched.investigatorEmailId ? (
                                                    <p className="errorMsg">{errors.investigatorEmailId}</p>) : null}
                                            </div>
                                        </li>
                                        <li className='col-md-4 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="investigatorContactNo" className="form-label">
                                                    Investigator Contact No.
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.investigatorContactNo && errors.investigatorContactNo ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Contact No."
                                                    name="investigatorContactNo"
                                                    disabled={action?.type === "View"}
                                                >
                                                </Field>
                                                {errors.investigatorContactNo && touched.investigatorContactNo ? (
                                                    <p className="errorMsg">{errors.investigatorContactNo}</p>) : null}
                                            </div>
                                        </li>
                                    </ul>
                                    <ul className='fieldArrayBoxUI row'>
                                        <li className='col-md-4 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="fieldSurveyorName" className="form-label">
                                                    Field Surveyor Name
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.fieldSurveyorName && errors.fieldSurveyorName ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Name"
                                                    name="fieldSurveyorName"
                                                    disabled={action?.type === "View"}
                                                >
                                                </Field>
                                                {errors.fieldSurveyorName && touched.fieldSurveyorName ? (
                                                    <p className="errorMsg">{errors.fieldSurveyorName}</p>) : null}
                                            </div>
                                        </li>
                                        <li className='col-md-4 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="fieldSurveyorEmailId" className="form-label">
                                                    Field Surveyor Email Id
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.fieldSurveyorEmailId && errors.fieldSurveyorEmailId ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Email Id"
                                                    name="fieldSurveyorEmailId"
                                                    disabled={action?.type === "View"}
                                                >
                                                </Field>
                                                {errors.fieldSurveyorEmailId && touched.fieldSurveyorEmailId ? (
                                                    <p className="errorMsg">{errors.fieldSurveyorEmailId}</p>) : null}
                                            </div>
                                        </li>
                                        <li className='col-md-4 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="fieldSurveyorContactNo" className="form-label">
                                                    Field Surveyor Contact No.
                                                </label>
                                                <Field
                                                    type="text"
                                                    className={`form-control ${touched.fieldSurveyorContactNo && errors.fieldSurveyorContactNo ? 'is-invalid' : ''}`}
                                                    placeholder="Enter Contact No."
                                                    name="fieldSurveyorContactNo"
                                                    disabled={action?.type === "View"}
                                                >
                                                </Field>
                                                {errors.fieldSurveyorContactNo && touched.fieldSurveyorContactNo ? (
                                                    <p className="errorMsg">{errors.fieldSurveyorContactNo}</p>) : null}
                                            </div>
                                        </li>
                                    </ul>
                                    <hr style={{ border: '2px solid black' }} />
                                    {action?.type !== "Add" &&
                                        <ul className='fieldArrayBoxUI row'>
                                            <li className='col-md-12 mb-4'>
                                                <div className="fieldArrayBox">
                                                    <label htmlFor="remarks" className="form-label">Remarks</label>
                                                    <Field
                                                        type="text"
                                                        className={`form-control ${touched.remarks && errors.remarks ? 'is-invalid' : ''}`}
                                                        placeholder="Enter Remarks"
                                                        name="remarks"
                                                        disabled
                                                    >
                                                    </Field>
                                                    {errors.remarks && touched.remarks ? (
                                                        <p className="errorMsg">{errors.remarks}</p>) : null}
                                                </div>
                                            </li>
                                            <li className='col-md-6 mb-4'>
                                                <div className="fieldArrayBox">
                                                    <div className='d-flex' style={{ justifyContent: "space-between", alignItems: "center" }}>
                                                        <label htmlFor="claimStatusId" className="form-label">
                                                            Claim Status *
                                                        </label>
                                                        {action?.claimDetails?.claimStatus !== "Withdrawn" && userRole === "Insurer" && action?.type === "Edit" &&
                                                            <div className='d-flex' style={{ width: "50%" }}>
                                                                <Field
                                                                    type="checkbox"
                                                                    id="openModalCheckbox"
                                                                    onChange={(e) => handleOpenModal(e.target.checked)}
                                                                    className="me-2"
                                                                    checked={nilFSRVALUE ? true : false}
                                                                />
                                                                <strong>Nil FSR</strong>
                                                            </div>
                                                        }
                                                    </div>
                                                    <Field
                                                        as="select"
                                                        className={`form-control`}
                                                        name="claimStatusId"
                                                        disabled
                                                    >
                                                        {/* <option>Select Claim Status</option> */}
                                                        {claimStatusDropdownList?.length > 0 && claimStatusDropdownList.map((status) =>
                                                            // <option key={status.id} value={status.id}>{status.name}</option>
                                                            <option key={status.id} value={nilFSRVALUE ? withdrawnId : status.id}>{nilFSRVALUE ? "Withdrawn" : status.name}</option>
                                                        )}
                                                    </Field>
                                                </div>
                                            </li>
                                            {/* <li className='col-md-6 mb-4'>
                                            <div className="fieldArrayBox">
                                                <label htmlFor="statusByUserId" className="form-label">
                                                    Status by User *
                                                </label>
                                                <Field
                                                    as="select"
                                                    className={`form-control`}
                                                    name="statusByUserId"
                                                    disabled
                                                >
                                                    <option>Select Status By User</option>
                                                    {statusByUserDropdownList?.length > 0 && statusByUserDropdownList.map((status) =>
                                                        <option key={status.id} value={status.id}>{status.name}</option>
                                                    )}
                                                </Field>
                                            </div>
                                        </li> */}
                                            <li className='col-md-6 mb-4'>
                                                <div className="fieldArrayBox">
                                                    <label htmlFor="currentStatusId" className="form-label">
                                                        Current Status *
                                                    </label>
                                                    <Field
                                                        as="select"
                                                        className={`form-control`}
                                                        name="currentStatusId"
                                                        onChange={(e) => setFieldValue('currentStatusId', e.target.value)}
                                                        disabled
                                                    >
                                                        {currentStatusDropdownList?.length && currentStatusDropdownList.map((status) =>
                                                            <option key={status.id} value={nilFSRVALUE ? currentStatusDropdownList.find(status => status.name === "Claim Rejected by Insurer")?.id : status?.id}>{nilFSRVALUE ? "Claim Rejected by Insurer" : status.name}</option>
                                                        )}
                                                    </Field>
                                                </div>
                                            </li>
                                        </ul>}
                                    {action?.claimDetails?.claimStatus !== "Withdrawn" &&
                                        <ModalFooter className="border-0">
                                            {!isLoading ? <Button color="primary" type="submit" className="ITC_Blue_color" disabled={nilFSRVALUE ? false : !dirty}>
                                                Submit
                                            </Button> : <Button color="primary" className="ITC_Blue_color" disabled>
                                                Submitting
                                            </Button>}
                                        </ModalFooter>}
                                </Form>
                            }
                        </Formik>
                    </ModalBody>
                </Modal >
                : null
            }
            {isModalOpen ? (
                <ClaimStatusFieldWithModal
                    closeModal={handleCloseModal}
                    isOpen={isModalOpen}
                    action={action}
                    nilFSRVALUE={nilFSRVALUE}
                    setNILFSRVALUE={setNILFSRVALUE}
                    setModalOpen={setModalOpen}
                />
            ) : null}
        </div >
    );
}
export default RaiseClaimModal;